























































































































































































































import { Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { UserStore } from '@/store/user-module';
import { stProjectApi } from '@/services/st-api';
import StProgress from '@/components/basic/StProgress.vue';
import { ProjectFilter, ProjectReportUserModel, ProjectReportViewModel, StSelectListItemGroup } from '@/services/api/nswag/stapiclient_generated';
import { roundToTwo } from '@/utlitities/helper';
import ld from 'lodash';

@Component({
  components: {
    StProgress,
  },
})
export default class ProjectReport extends Vue {
  projectId!: number;
  reportModel?: ProjectReportViewModel = ProjectReportViewModel.fromJS({});
  loading = true;
  dataAvailable = false;
  userChartHoursOptions = {};
  userChartRevenueOptions = {};
  projects: StSelectListItemGroup[] = [];

  get currency() {
    return UserStore.userSettings.currency;
  }

  created() {
    this.projectId = +this.$route.params.projectid;
  }

  mounted() {
    this.loadData();
  }

  get canViewRates() {
    return UserStore.userSettings.CanViewRates && !UserStore.userSettings.noRates;
  }

  get useInternalUserCost() : boolean {
    return UserStore.userSettings.useInternalUserCost;
  }

  changeProject(projectId: number) {
    this.$router.push({ name: this.$route.name!, params: { projectid: projectId.toString() } });
    this.loadData();
  }

  getUserPercentage(user: ProjectReportUserModel) {
    return ((user.hours || 1) / (this.reportModel?.hours || 1)) * 100;
  }

  getUserPercentageLabel(user: ProjectReportUserModel) {
    return Math.round(((user.revenueBillable || 1) / (this.reportModel?.revenueBillable || 1)) * 1000) / 10 + '%';
  }

  async loadData() {
    this.loading = true;
    this.projects = await stProjectApi.getSelectListForProjectReport();
    this.reportModel = await stProjectApi.getProjectReport(this.projectId);

    await this.generateUserChartHours();
    await this.generateUserChartRevenue();
    this.loading = false;
    this.dataAvailable = true;
  }

  getTimeRevenueChartMax(): number {
    //da das Chart nicht automatisch weiß, dass es bis zum größten skalieren muss, müssen wir das hier berechnen
    if (this.reportModel && this.reportModel.timeFrameModel)
    {
      let maxRevenue = ld.max(this.reportModel?.timeFrameModel?.map((entry) => entry.revenue)) ?? 0;
      let maxCost = ld.max(this.reportModel?.timeFrameModel?.map((entry) => entry.cost)) ?? 0;
      return maxRevenue >= maxCost ? maxRevenue * 1.5 : maxCost * 1.5;
    }

    return 0;
  }

  get timeRevenueChartOptions() {
    let data = {
      series: [
        {
          name: this.$t('Stunden').toString(),
          type: this.useInternalUserCost ? 'line' : 'bar',
          data: this.reportModel?.timeFrameModel?.map((entry) => entry.hours),
        },
        {
          name: this.$t('Umsatz').toString(),
          type: this.useInternalUserCost ? 'bar' : 'line',
          data: this.reportModel?.timeFrameModel?.map((entry) => entry.revenue),
        },
        {
          name: this.$t('Kosten').toString(),
          type: 'bar',
          data: this.reportModel?.timeFrameModel?.map((entry) => entry.cost),
        },
      ],
      chartOptions: {
        chart: {
          height: 350,
        },
        colors: ['#357ebd', '#5cb85c', '#d24545'],
        plotOptions: {
          bar: {
            endingShapes: 'round',
            columnWidth: '50px',
          },
        },
        stroke: {
          width: [2, 2, 2],
          dashArray: [0, 0, 0],
        },
        dataLabels: {
          enabled: false,
        },
        labels: this.reportModel?.timeFrameModel?.map((entry) => {
          if (this.reportModel?.displayTimeChartDaily) {
            return this.$options.filters?.formatDate(entry.date);
          } else {
            return this.$options.filters?.formatMonth(entry.date);
          }
        }),
        xaxis: {
          type: 'string',
        },
        yaxis: [
          {
            seriesName: this.$t('Stunden').toString(),
            title: {
              text: this.$t('Stunden').toString(),
            },
            labels: {
              formatter: (value: any) => {
                return this.$options.filters?.formatNumber(value);
              },
            },
          },
          {
            seriesName: this.$t('Umsatz').toString(),
            title: {
              text: this.$t('Umsatz').toString(),
            },
            opposite: true,
            show: true,
            forceNiceScale: true,
            labels: {
              formatter: (value: any) => {
                return this.$options.filters?.formatNumber(value);
              },
            },
          },
          {
            seriesName: this.$t('Umsatz').toString(),
            title: {
              text: this.$t('Umsatz').toString(),
            },
            opposite: true,
            show: false,
            forceNiceScale: true,
            labels: {
              formatter: (value: any) => {
                return this.$options.filters?.formatNumber(value);
              },
            },
          }
        ],
      },
    };

    if (!this.canViewRates) {
      //remove Umsatz und Kosten
      data.series.splice(1, 2);
      data.chartOptions.yaxis.splice(1, 2);
      data.chartOptions.colors.splice(1, 2);
      (data.chartOptions.chart as any).type = 'line';
    }

    if (this.canViewRates && !this.useInternalUserCost)
    {
      //remove Kosten
      data.series.splice(2, 1);
      data.chartOptions.yaxis.splice(2, 1);
      data.chartOptions.colors.splice(2, 1);
      (data.chartOptions.chart as any).type = 'line';
    }

    return data;
  }

  async generateUserChartHours() {
    this.userChartHoursOptions = {
      series: this.reportModel?.userModel?.map((user) => user.hours),
      chartOptions: {
        chart: {
          type: 'pie',
          width: 380,
        },
        colors: ['#2980B9', '#5CB85C', '#5BC0DE', '#F0AD4E', '#D9534F', '#428BCA', '#B57C20', '#4AC499', '#A6D9E2', '#C44AB2', '#4AC45C', '#E2AFA6', '#D38678', '#C44A75'],
        tooltip: {
          y: {
            formatter: (value: number) => roundToTwo(value) + ' h (' + Math.round((value / (this.reportModel?.hours || value)) * 1000) / 10 + '%)',
          },
        },
        stroke: {
          width: [0, 4],
        },
        dataLabels: {
          enabled: true,
        },
        labels: this.reportModel?.userModel?.map((user) => user.userFullName),
      },
    };
  }

  async generateUserChartRevenue() {
    this.userChartRevenueOptions = {
      series: this.reportModel?.userModel?.map((user) => user.revenueBillable),
      chartOptions: {
        chart: {
          type: 'pie',
          width: 380,
        },
        colors: ['#2980B9', '#5CB85C', '#5BC0DE', '#F0AD4E', '#D9534F', '#428BCA', '#B57C20', '#4AC499', '#A6D9E2', '#C44AB2', '#4AC45C', '#E2AFA6', '#D38678', '#C44A75'],
        tooltip: {
          y: {
            formatter: (value: number) => roundToTwo(value) + ' ' + this.currency + ' (' + Math.round((value / (this.reportModel?.revenueBillable || value)) * 1000) / 10 + '%)',
          },
        },
        stroke: {
          width: [0, 4],
        },
        dataLabels: {
          enabled: true,
        },
        labels: this.reportModel?.userModel?.map((user) => user.userFullName),
      },
    };
  }

  back() {
    this.$router.push({ name: 'Projects' });
  }
}
